import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import SendEmailToLeadModalUI from './SendEmailToLeadModalUI'

class SendEmailToLeadModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,

      // form events
      submitted: false,
      // form field
      email: '',
      emailError: null,
      directorName: '',
      directorNameError: null,
    }
  }

  render() {
    return (
      <SendEmailToLeadModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        emailToLeadMode={this.props.emailToLeadMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelEmailToLead}
        // form fields
        email={this.state.email}
        onEmailChange={(event) => this.setState({ email: event.target.value })}
        emailError={this.state.emailError}
        setEmailError={(error) => { this.setState({ emailError: error }) }}
        //
        directorName={this.state.directorName}
        onDirectorNameChange={(event) => this.setState({ directorName: event.target.value })}
        directorNameError={this.state.directorNameError}
        setDirectorNameError={(error) => { this.setState({ directorNameError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/leads/emails/welcome`,
      this.onSubmitCallback, {
      email: this.state.email,
      directorName: this.state.directorName,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response && response.errorList) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    let respErrors = Array.isArray(response.errorList) ? response.errorList : [];

    if (respErrors.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelEmailToLead()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(SendEmailToLeadModalSF)
